export default __webpack_public_path__ + "static/media/footer-fade.c858d45e.png";